import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Heights extends Component {
  render() {
    return (
      <EntityList apiRoute='api/heights' title='Remorque - Hauteurs' editTitle='Hauteur' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Valeur', Column: 'Value'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Heights;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/heights.js
 **/